import { ReactElement } from 'react';
import { Stack, Avatar, Typography, Chip, ChipProps } from '@mui/material';
import { green, red, grey } from '@mui/material/colors';
import { DonutLarge, HourglassEmpty } from '@mui/icons-material';
import { t } from 'i18next'
import { getCurrencyText } from "../../../shared/utils/hubstripe.js";

type BillingSubscriptionsItemsRowProps = {
    lineItem: any
}

function BillingSubscriptionsItemsRow({ lineItem }: BillingSubscriptionsItemsRowProps) {

    var a = new Date(lineItem.next_invoice_date * 1000);

    var chipLabel = ""
    var chipColor: ChipProps['color'] = 'default';
    var avatarColor = ""
    var avatarIcon: ReactElement = <></>


    switch (lineItem.status) {
        case "active":
            if (lineItem.next_invoice_date == null) {
                chipLabel = t("billing:pause")
                chipColor = "default"
                avatarColor = grey[500]
            }
            else {
                chipLabel = t("billing:active")
                chipColor = "success"
                avatarColor = green[500]
            }
            avatarIcon = <DonutLarge sx={{ color: 'white' }} />
            break;

        case "past_due":
            chipLabel = t("billing:past_due")
            chipColor = "error"
            avatarColor = red[500]
            avatarIcon = <DonutLarge sx={{ color: 'white' }} />
            break;

        case "not_started":
            chipLabel = t("billing:start_on") + " " + a.toLocaleDateString()
            chipColor = "default"
            avatarColor = grey[500]
            avatarIcon = <HourglassEmpty sx={{ color: 'white' }} />
            break;

        default:
            break;
    }

    return (
        <Stack direction={"row"} spacing={1} alignItems="center">
            <Avatar sx={{ bgcolor: avatarColor,alignSelf:'self-start' }} variant="rounded">
                {avatarIcon}
            </Avatar>
            <Stack spacing={0}>
                <Stack direction="row" flexWrap={'wrap'} spacing={1}>
                    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                        {lineItem.name}
                        {lineItem.quantity > 1 && (
                            " X " + lineItem.quantity
                        )}
                    </Typography>
                    <Chip label={chipLabel} color={chipColor} size="small" />
                </Stack>

                <Typography variant="body1" sx={{ color: "#808080" }}>
                    {lineItem.next_invoice_date == null && (
                        <div>
                            {t("billing:title")} {t("billing:" + lineItem.interval)} {t("billing:for")} {getCurrencyText(lineItem.next_invoice_amount / 100, lineItem.currency)}
                        </div>
                    ) || (
                            <div>
                                {t("billing:title")} {t("billing:" + lineItem.interval)} • {t("billing:next_invoice_on")} {a.toLocaleDateString()} {t("billing:for")} {getCurrencyText(lineItem.next_invoice_amount / 100, lineItem.currency)}
                            </div>
                        )}
                </Typography>
            </Stack >
        </Stack>

    );
}

export default BillingSubscriptionsItemsRow;
